import './HomePage.css';
import React, { FC } from 'react';
import { AppHeaderComponent } from '../../components/app-header/AppHeaderComponent';
import { Button } from '@mui/material';
import { useLocalizedNavigate } from '../../hooks/useLocalizedNavigate';
import { AboutSection } from '../../components/home/about-section/AboutSection';
import { HowSection } from '../../components/home/how-section/HowSection';
import { useTranslation } from 'react-i18next';
import { TherapistSection } from '../../components/home/therapist-section/TherapistSection';
import { PartnersSection } from '../../components/home/partners-section/PartnersSection';
import { FaqSection } from '../../components/home/faq-section/FaqSection';
import { FaqJsonLd } from '../../components/seo/FaqJsonLd';
import { SeoHead } from '../../components/seo/SeoHead';

export const HomePage: FC = () => {
    const { t, i18n } = useTranslation();
    const navigate = useLocalizedNavigate();

    const navigateToTherapists = () => {
        navigate('/trps');
    };

    return (
        <>
            <SeoHead
                helmetKey={i18n.language}
                title={String(
                    t(
                        'home.helmet.title',
                        'BalancePath - Online Psychotherapy in Multiple Languages',
                    ),
                )}
                description={String(
                    t(
                        'home.helmet.description',
                        'Online psychotherapy in 5 languages. Connect with licensed therapists and book sessions from home.',
                    ),
                )}
                basePath="/"
            />
            <FaqJsonLd />
            <AppHeaderComponent />
            <div className="home-background">
                <div className="home-container">
                    <div className="home-content">
                        <div className="home-bullets home-bullets-lead">
                            <p className="home-description home-h1">
                                <span className="home-bullet-dot" />
                                {t('home.helmet.title')}
                            </p>
                        </div>
                        <h1
                            className="home-title"
                            style={{
                                fontFamily: "'Playfair Display', serif",
                                letterSpacing: '1px',
                            }}
                        >
                            {t('home.section0.title')}
                        </h1>
                        <div className="home-bullets">
                            <p className="home-description">
                                <span className="home-bullet-dot" />
                                {t('home.section0.topics')}
                            </p>
                            <p className="home-description">
                                <span className="home-bullet-dot" />
                                {t('home.section0.subtitle')}
                            </p>
                            <p className="home-description">
                                <span className="home-bullet-dot" />
                                {t('home.section0.discreteOnline')}
                            </p>
                        </div>
                        <div className="hero__button">
                            <Button
                                variant="contained"
                                style={{
                                    backgroundColor: '#D32F2F',
                                    color: '#FFFFFF',
                                    borderRadius: '50px',
                                    height: '50px',
                                    width: '300px',
                                    fontWeight: 'bold',
                                    letterSpacing: '1px',
                                }}
                                size="large"
                                onClick={navigateToTherapists}
                            >
                                {t('home.section0.findYourTherapist')}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <AboutSection />
            <HowSection />
            <TherapistSection />
            <FaqSection />
            <PartnersSection />
        </>
    );
};
